import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { API } from "@/lib/api";

const fetchCounts = async () => {
  const r = await fetch(`${API}/reviews/media-counts`);
  if (!r.ok) throw new Error("media counts failed");
  return r.json();
};

// Dots sit NE of the country position so they never cover the micro-state flag pins.
const OFFSET = [12, -12];

/** Countries with approved visitor photos/videos, projected to map coordinates: [{code, count, x, y}]. */
export function useMediaCounts(countries, project) {
  const { data: counts = {} } = useQuery({ queryKey: ["media-counts"], queryFn: fetchCounts, staleTime: 60_000 });
  return useMemo(() => {
    if (!project) return [];
    return countries
      .filter((c) => counts[c.code] > 0 && c.position)
      .map((c) => {
        const [x, y] = project(c.position.lng, c.position.lat);
        return { code: c.code, count: counts[c.code], x: x + OFFSET[0], y: y + OFFSET[1] };
      });
  }, [countries, counts, project]);
}
